import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '@/views/LoginView';
import RegisterView from '@/views/RegisterView';
// import PatientView from '@/views/PatientView';
import AccountFormsView from '@/views/AccountFormsView';
import AccountPresetsView from '@/views/AccountPresetsView';
import AccountSubmissionsView from '@/views/AccountSubmissionsView';
import AccountSettingsView from '@/views/AccountSettingsView';
import FormEditorView from '@/views/FormEditorView'
import FormFillerView from '@/views/FormFillerView';
import AdminPortalView from '@/views/AdminPortalView'
import CheckInView from '@/views/CheckInView'
import FormDraftView from '@/views/FormDraftView.vue';
import PDFFormEditorView from '@/views/v2/PDFFormEditorView.vue';
import PublicPortalView from '@/views/PublicPortalView.vue';
import HTMLFormEditorView from '@/views/v2/HTMLFormEditorView.vue';

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView
  },
  {
    path: '/pdf-editor/:id',
    name: 'PDF Form Editor',
    component: PDFFormEditorView
  },
  {
    path: '/html-editor/:id',
    name: 'HTML Form Editor',
    component: HTMLFormEditorView
  },
  {
    path: '/forms/:id',
    name: 'Form Editor',
    component: FormEditorView
  },
  {
    path: '/forms-draft',
    name: 'Form Draft',
    component: FormDraftView
  },
  {
    path: '/submission/:privateUrl',
    name: 'Patient View',
    component: FormFillerView
  },
  {
    path: '/forms',
    name: 'Account Forms',
    component: AccountFormsView
  },
  {
    path: '/presets',
    name: 'Account Presets',
    component: AccountPresetsView
  },
  {
    path: '/submissions',
    name: 'Account Submissions',
    component: AccountSubmissionsView
  },
  {
    path: '/settings',
    name: 'Account Settings',
    component: AccountSettingsView
  },
  {
    path: '/:office/:url',
    name: 'Form Filler',
    component: FormFillerView
  },
  {
    path: '/admin',
    component: AdminPortalView
  },
  {
    path: '/checkin/:uniqueName',
    name: 'Check In View',
    component: CheckInView
  },
  {
    path: '/p/:uniqueName',
    name: 'Public Portal View',
    component: PublicPortalView
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: 'is-active'
})

export default router;